/**
 * Node modules
 */
import Select from 'antd/lib/select';

export default Select.OptGroup;
